import { keyScale, keySignature, keyTonics, type MusicalKey } from "./key";

export interface CircleEntry {
  major: MusicalKey; // conventional spelling, e.g. F#, Db
  minor: MusicalKey; // relative minor as a selectable key (conventional spelling)
  minorName: string; // relative minor spelled from the major scale (e.g. D# for F# major)
  signature: number; // +sharps / −flats
}

/** The circle of fifths clockwise from C: each step is a perfect fifth up (one more sharp / one fewer flat). */
export function circleOfFifths(): CircleEntry[] {
  return Array.from({ length: 12 }, (_, i) => {
    const pc = (i * 7) % 12;
    const major: MusicalKey = { tonic: keyTonics("major")[pc]!, mode: "major" };
    const minorPc = (pc + 9) % 12;
    return {
      major,
      minor: { tonic: keyTonics("minor")[minorPc]!, mode: "minor" },
      minorName: keyScale(major).notes[5]!,
      signature: keySignature(major),
    };
  });
}

/** Steps around the circle between two keys' major (or relative-major) positions: 0 = same, ±1 = neighbours. */
export function circleDistance(a: MusicalKey, b: MusicalKey): number {
  const circle = circleOfFifths();
  const idx = (k: MusicalKey) => circle.findIndex((e) => (k.mode === "major" ? e.major.tonic === k.tonic : e.minor.tonic === k.tonic));
  let d = idx(b) - idx(a);
  if (d > 6) d -= 12;
  if (d < -6) d += 12;
  return d;
}
